// extracted by mini-css-extract-plugin
export default {"sidebar":"Header_sidebar__mBtFM","slide-top":"Header_slide-top__B03-y"};